import {
  always,
  applySpec,
  assoc,
  clone,
  compose,
  find,
  identity,
  ifElse,
  includes,
  indexBy,
  isEmpty,
  isNil,
  map,
  mapObjIndexed,
  pathEq,
  pathOr,
  prop,
  propEq,
  reduce
} from "ramda";
import {defaultOr, divideTo, normalize, nothing, slugIs} from "../../lib/utils";

const convertToCur = (currencyRate = 0) => mapObjIndexed(
  ifElse(
    (v, key) => includes(key, ['min', 'max', 'step', 'value']),
    (val, key) => {
      let result = divideTo(currencyRate, val);
      switch (key) {
        case 'min':
        case 'max':
        case 'step':
          result = result.toFixed(6);
          break;
      }
      return parseFloat(result);
    },
    identity
  )
);

const getResource = (field) => (state, getters) => {
  return pathOr({}, ['localResources', field, 'value'], getters);
};

export default {
  /**
   * Вычисление выбранной линии
   * Возвращает объект линии
   * @returns {object}
   */
  currency(state) {
    return defaultOr(
      {"id": "1", "name": "Рубль", "country_iso": "RU", "symbol": "₽", "code": "RUB", "rate": 1},
      find(propEq('code', state.currencyCode), state.currencies)
    );
  },
  currencyCode(state, getters) {
    return getters.currency ? getters.currency.code : 'RUB';
  },
  currencyRate(state, getters) {
    return getters.currency ? getters.currency.rate : 1;
  },

  currencySelect(state) {
    return ifElse(
      isNil, nothing,
      map(applySpec({
        text: prop('name'),
        value: prop('code')
      }))
    )(state.currencies)
  },
  hideChange(state, getters) {
    return ['UZS', 'KZT'].includes(getters.currencyCode)
  },
  LineSelect(state) {
    return map(applySpec({
      text: prop('label'),
      value: prop('slug')
    }), state.lines);
  },

  localPrice: getResource('price'),
  localEnergyTariff: getResource('energyTariff'),
  localRent: getResource('rent'),
  localTariff: getResource('tariff'),

  localIngredientPrices(state, getters) {
    return reduce((m, c) => {
      m[c.name] = c.price.value;
      return m;
    }, {}, getters.localIngredients)
  },
  localIngredientOptions(state, getters) {
    return ifElse(
      isEmpty, always({}),
      compose(
        mapObjIndexed(prop('value')),
        prop('index')
      )
    )(getters.recipe);
  },
  localIngredients(state, getters) {
    return compose(
      map(applySpec({
        "id": prop('id'),
        "name": prop('name'),
        "label": prop('label'),
        "measure": prop('measure'),
        purchase: applySpec({
          measure: prop('purchase_measure'),
          multiplier: prop('measure_multiplier')
        }),
        price: (ing) => ifElse(
          isNil,
          compose(
            convertToCur(getters.currencyRate),
            always({
              min: ing.min_price,
              max: ing.max_price,
              step: ing.step,
              value: ing.price
            })
          ),
          identity
        )(find(pathEq(['currency', 'code'], state.currencyCode), ing.prices))
      }))
    )(state.ingredients);
  },
  localResources(state, getters) {
    return compose(
      reduce((m, c) => {
        m[c.name] = c;
        return m;
      }, {}),
      map(applySpec({
        "id": prop('id'),
        "name": prop('name'),
        "label": prop('label'),
        purchase: applySpec({
          measure: prop('purchase_measure'),
          multiplier: prop('measure_multiplier')
        }),
        value: (ing) => ifElse(
          isNil,
          compose(
            convertToCur(getters.currencyRate),
            always({
              min: ing.min_price,
              max: ing.max_price,
              step: ing.step,
              value: ing.price
            })
          ),
          identity
        )(find(pathEq(['currency', 'code'], state.currencyCode), ing.prices))
      }))
    )(state.resources);
  },


  /**
   * Вычисление выбранной линии
   * Возвращает объект линии
   * @returns {object}
   */
  line(state) {
    return ifElse(
      isNil, nothing, // Проверка на отсутствие выбранной линии
      find(slugIs(state.currentLine))
    )(state.lines)
  },

  lineSelectOptions(state) {
    return map(applySpec({
      text: prop('label'),
      value: prop('slug')
    }), state.lines);
  },

  /**
   * Вычисляет выбранный рецепт
   * Возвращает объект рецерта
   * @returns {object}
   */
  recipe(store) {
    return ifElse(
      isEmpty, nothing,
      compose(
        (recipe) => assoc('index', indexBy(prop('name'), recipe.ingredients), recipe),
        (recipe) => assoc('ingredients', normalize(recipe.ingredients), recipe),
        clone,
        find(propEq('name', store.currentRecipe)),
      )
    )(store.recipes);
  }
}
